// import React from 'react';
// import './Footer.css'
// import { FormattedMessage } from "react-intl";
// import publicAccount from '../../config/images/publicAccount.jpg';
// import publicImg from '../../config/images/public.jpg';

// import hui from './images/hui.png'
// import gonzhonghao from './images/gonzhonghao.png'
// import fuwwuhao from './images/fuwwuhao.png'


// export default function Footer() {
//     return (

//         <div className='footer' style={{ display: 'flex', }}>


//             <div style={{ marginLeft: 30, width: 514, marginTop: 18}}>
//                 <div>地址：北京市昌平区霍营街道回龙观东大街296号龙冠和谐大厦难楼三层305层</div>
//                 <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5 }}>
//                     <div>版本：V3.0.17</div>
//                     <div>
//                         <img src={hui} alt="" style={{ height: 18 }} />
//                         <span style={{marginLeft: 5,marginRight: 2}}>ICP备案/许可证号：京ICP备2023037560号-2</span>
//                     </div>
//                 </div>
//             </div>
//             <div style={{marginLeft: 50, marginTop: 18}}>
//                 <div>联系我们：冯经理17863954131(微信同号)</div>
//             </div>
//             <div style={{display: 'flex', marginLeft: 50}}>
//                 <div style={{marginTop: 18}}>公众号</div>
//                 <img src={gonzhonghao} alt="" style={{ height: 70 , marginTop: 10, marginLeft: 5}} />
//             </div>
//             <div style={{display: 'flex', marginLeft: 50}}>
//                 <div style={{marginTop: 18}}>服务号</div>
//                 <img src={fuwwuhao} alt="" style={{ height: 70, marginTop: 10, marginLeft: 5 }} />
//             </div>

//         </div>
//     )
// }


import React from 'react';
import './Footer.css'
import { FormattedMessage } from "react-intl";
import publicAccount from '../../config/images/publicAccount.jpg';
import publicImg from '../../config/images/public.jpg'
export default function Footer() {
    return (
        // <div className='footer' >
        //     <div className='no'>
        //         <div className='footerCont'  style={{ display: 'flex', justifyContent: 'space-around' }}>
        //             <div></div>

        //             <div style={{ marginTop: 28 }}>
        //                 <p style={{ padding: 0, margin: 0, marginLeft: 50, textAlign: 'center', marginTop: 12 }}>地址：北京市昌平区霍营街道回龙观东大街298号 龙冠和谐大厦三层 318</p>
        //                 <p style={{ padding: 0, margin: 0, marginLeft: 50, marginTop: 5 }}>
        //                     <span>ICP备案/许可证号：京ICP备2023037560号-2</span>
        //                     <span style={{ display: 'inline-block', marginLeft: 15 }}>版本：V3.0.1</span>
        //                 </p>
        //                 <p style={{ padding: 0, margin: 0, marginLeft: 50, marginTop: 5 }}></p>
        //             </div>

        //             <div>
        //                 <div style={{ fontSize: 15, marginTop: 5 }}>联系我们：宋斌 13810617073（微信同号）</div>
        //                 {/* <div style={{marginLeft: 12,fontSize: 14,marginTop: '-15px'}}></div> */}
        //                 <img src={publicAccount} alt="" style={{ width: 80, height: 80, marginLeft: 34, marginTop: 3 }} />
        //                 <img src={publicImg} alt="" style={{ width: 80, height: 80, marginLeft: 10, marginTop: 3 }} />
        //             </div>
        //         </div>

        //     </div>

        // </div>
        <div className='footer'>
            <div style={{ marginLeft: 50 }}>版本：V3.0.17</div>

            <div style={{ marginLeft: 30 }}>地址：北京市昌平区霍营街道回龙观东大街298号 龙冠和谐大厦三层 318</div>
            <div style={{ marginLeft: 30 }}>ICP备案/许可证号：京ICP备2023037560号-2</div>
            <div style={{ marginLeft: 30 }}>联系我们：周经理 13391868210（微信同号） </div>
            <div className="publicAccount">
                <span style={{ marginLeft: 30 }}>公众号</span>
                <div className="publicAccountImg" >
                    <img src={publicAccount} alt="二维码" style={{ width: 120, height: 120 }} />
                </div>
            </div>
            <div className="publicAccount">
                <span style={{ marginLeft: 30 }}>服务号</span>
                <div className="publicAccountImg" >
                    <img src={publicImg} alt="二维码" style={{ width: 120, height: 120 }} />
                </div>
            </div>

        </div>
    )
}
